import { Mapper } from 'src/base/mapper'
import { SubDistrictTypeEntity } from 'src/data/entities/common.entity'
import { SubDistrictTypeModel } from 'src/domain/models/common.model'

export class SubDistrictMapper extends Mapper<SubDistrictTypeEntity, SubDistrictTypeModel> {
	mapFrom(param: SubDistrictTypeEntity): SubDistrictTypeModel {
		return this.resultData(param)
	}

	mapTo(param: SubDistrictTypeModel): SubDistrictTypeEntity {
		return this.resultData(param)
	}

	resultData(param: SubDistrictTypeEntity | SubDistrictTypeModel) {
		return {
			subDistrictCode: param.subDistrictCode,
			subDistrictName: param.subDistrictName,
		}
	}
}
